import axios from 'axios'
import constant from '@/constant'

const mail_history_index = {
  namespaced: true,

  state() {
    return {
      search_conditions: {
        id: null,
        subject: null,
        body: null,
        user_id: null,
        mailed_at: null,
        is_read: null,
      },
      paginationStatus: {
        from: null,
        to: null,
        total: null,
        current_page: null,
        last_page: null,
        per_page: constant.NOTIFICATER.PER_PAGE,
      },
      sortStatus: {
        column: null,
        ascending: false,
      },
      unreadCount: 0,
      lastMailHistoryId: null,
      isNewMail: false,
      mailHistories: [],
      errors: {},
    }
  },

  getters: {
    getParameter(state) {
      return {
        ...state.search_conditions,
        sort_attribute: state.sortStatus.column,
        sort_direction: state.sortStatus.ascending ? 'asc' : 'desc',
        page: state.paginationStatus.current_page,
        per_page: state.paginationStatus.per_page,
      };
    },
  },

  mutations: {
    setData(state, data) {
      state.mailHistories = data;
      state.errors = {};
    },
    resetData(state) {
      state.search_conditions.id = null;
      state.search_conditions.subject = null;
      state.search_conditions.body = null;
      state.search_conditions.user_id = null;
      state.search_conditions.mailed_at = null;
      state.search_conditions.is_read = null;
      state.paginationStatus.from = null;
      state.paginationStatus.to = null;
      state.paginationStatus.total = null;
      state.paginationStatus.current_page = null;
      state.paginationStatus.last_page = null;
      state.paginationStatus.per_page = constant.NOTIFICATER.PER_PAGE;
      state.sortStatus.column = null;
      state.sortStatus.ascending = false;
      state.mailHistories = [];
      state.errors = {};
    },
    addMailHistories(state, data) {
      const additionalData = data.filter(addItem => {
        return !state.mailHistories.some(oldItem => oldItem.id === addItem.id);
      });
      state.mailHistories = state.mailHistories.concat(additionalData);
      state.errors = {};
    },
    setMailHistorySummary(state, data) {
      state.unreadCount = data.count;
      state.isNewMail =  data.maxId > state.lastMailHistoryId;
      state.lastMailHistoryId = data.maxId;
    },
    setErrors(state, errors) {
      state.errors = { ...errors };
    },
    setMeta(state, meta) {
      state.paginationStatus = {
        from: meta.from,
        to: meta.to,
        total: meta.total,
        current_page: meta.current_page,
        last_page: meta.last_page,
        per_page: meta.per_page,
      };
    },
    setCurrentPage(state, payload) {
      state.paginationStatus.current_page = payload.value;
    },
    setCurrentPageCountUp(state) {
      state.paginationStatus.current_page++;
    },
    setPerPage(state, payload) {
      state.paginationStatus.per_page = payload.value;
    },
    setIsRead(state, index) {
      state.mailHistories[index].is_read = true;
      state.unreadCount--;
    },
    setIsReadSearchValue(state, payload) {
      state.search_conditions.is_read = payload;
    },
  },

  actions: {
    load({ commit, getters }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/mail_histories', {params: getters.getParameter}).then((response) => {
          if (response.data.data.length > 0) {
            commit('setData', response.data.data);
            commit('setMeta', response.data.meta);
          }
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({ handled });
        });
      });
    },
    loadAdditionalData({ commit, getters }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/mail_histories', {params: getters.getParameter}).then((response) => {
          if (response.data.data.length > 0) {
            commit('addMailHistories', response.data.data);
            commit('setMeta', response.data.meta);
          }
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({ handled });
        });
      });
    },
    getMailHistorySummary({ commit }) {
      return new Promise((resolve, reject) => {
        // 未読のメール件数を取得
        axios.get('/api/mail_histories/count', {params: {is_read: 0}}).then((response) => {
            commit('setMailHistorySummary', response.data.data);
          resolve(true);
        }).catch(() => reject());
      });
    },
  },
};

export default mail_history_index;
